var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"href":"/","text":"","exact":""}},[_c('div',{staticClass:"d-flex align-center"},[_c('v-img',{staticClass:"shrink mr-2 logo-white",attrs:{"alt":"Vuetify Logo","contain":"","src":require('@/assets/logo_2.svg'),"transition":"scale-transition","width":"70"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }